export default __webpack_public_path__ + "static/media/ic_user.41dc3560.svg";